export default __webpack_public_path__ + "static/media/r2.8a18923a.jpg";